<template>
  <div class="wrapper">
    <slot></slot>
    <div class="buttons" >
      <Button class="button"  @click.stop="cancel">重置</Button>
      <Button class="button2" @click.stop="save" type="primary">保存</Button>
    </div>
  </div>

</template>

<script>
  export default {
    data(){
      return {
      }
    },
    methods:{
      save(){
        this.$emit('save')
      },
      cancel(){
        this.$emit('cancel')
      }
    }
  }
</script>

<style scoped>
.buttons{
  margin-top: 5%;
  text-align: center;

}
  .button,.button2{
    width: 150px;
    line-height: 1.8;
  }
  .button2{
    margin-left: 50px;
  }
  .wrapper{
    padding-bottom: 5%;
  }
</style>
